import { api } from "./clientInstance";

// Start an anonymous "Try it" session: the backend mints a throwaway account
// with a ready-to-play team (default GeneralTactic tokens are shipped from the
// frontend, same as team creation). Returns { user, access_token }.
export function startGuest(defaultTactic) {
  return api("/guest", {
    method: "POST",
    body: JSON.stringify({ DefaultTactic: defaultTactic }),
  });
}

// Upgrade the CURRENT guest account into a real one, in place. The guest's
// team/tactics/players are kept; only credentials + team name are set.
// Returns { user, access_token }.
export function registerGuest(payload) {
  return api("/guest/register", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
